<template>
  <div>
    <v-card
    class="mx-auto my-12 px-8"
    max-width="374"
    style="border-radius:40px;"
    >
    
      <v-img
        height="180"
        :src="one.logoUrl"
        :lazy-src="one.logoLazyUrl"
        contain
      ></v-img>

      <v-card-title class="justify-center">
        <span v-if="promoIsActiveForOffer(one.id)">
          <span class="mx-1" style="color:#e23a05; font-weight: bold">{{ one.price - promo.discount }}€</span>
          <span class="mx-1" style="text-decoration: line-through; color: #AAA">{{ one.price }}€</span>
        </span>
        <span v-else>
          {{ one.price }}€
        </span>
      </v-card-title>

      <v-card-text>
        <div class="d-flex justify-center">
          <v-btn rounded depressed color="#ef6758" style="color:white" :to="{path: `/mon-projet/${one.iso}`}">
            {{ one.call2action }}
          </v-btn>
        </div>
        <p v-if="promoIsActiveForOffer(one.id)" class="text-center my-3" v-html="promo.label"></p>
        <div class="text-left my-8" v-html="one.description"></div>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          color="#ef6758"
          text
          :to="{path: `/nos-offres/${one.iso}`}"
        >
          {{ one.more2action }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    one: Object
  },
  computed: {
    ...mapGetters('strapiv2', ['promo', 'promoIsActive', 'promoIsActiveForOffer'])
  }
}
</script>